import { generatePath, Link as RouterLink } from "react-router-dom";

import { Stack, Typography, Link, Button } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import _ from "lodash";

import { PublicRoutesConfig } from "../../RoutesConfig";
import SectionPreview from "../../../common/components/SectionPreview";
import { dateToStringShort, dateToStringLongSuffix } from "../../../common/utils/dateTime";
import { formatNotaryData } from "../../../common/utils/formatters";
import { apiFileDownloadEndpoint } from "../../../common/components/mui-extended/DropzoneExtended";
import { AuthorizationPreviewDto } from "../../../interfaces/Authorization";

type AuthorizationProps = {
  model?: AuthorizationPreviewDto;
};

const Authorization = ({ model }: AuthorizationProps) => {
  const renderAutorizationData = () => (
    <>
      <Typography>
        {_.join(
          _.map(model?.authorizationRegisters, (nom) => nom.name),
          ", "
        )}{" "}
        <strong>{`${model?.registrationNumber} / ${dateToStringShort(model?.issueDate)}`}</strong>
      </Typography>
      <Typography>
        издадено от нотариус <strong>{model?.notary?.name}</strong>, номер{" "}
        <strong>{_.padStart(model?.notary?.number?.toString(), 3, "0")}</strong>, район на действие{" "}
        <strong>{model?.notary?.settlementName}.</strong>
      </Typography>
    </>
  );

  const render = () => {
    return (
      <Stack spacing={3}>
        <Typography variant="subtitle2">
          Дата на въвеждане в регистъра: {dateToStringLongSuffix(model?.createDate)}
        </Typography>
        <SectionPreview title="Данни за пълномощно">{renderAutorizationData()}</SectionPreview>
        <SectionPreview title="Документи, с които се оттегля пълномощното">
          {model?.withdrawnAuthorizations?.map((item) => (
            <Link
              key={item.withdrawnAuthorizationId}
              component={RouterLink}
              to={generatePath(PublicRoutesConfig.WithdrawnAuthorization.Preview.Path, {
                id: item.withdrawnAuthorizationId.toString(),
              })}
              color="secondary"
              underline="hover"
            >
              <Typography>{`${formatNotaryData(item.notary?.name, item.notary?.number)}, ${
                item.registrationNumber
              } / ${dateToStringShort(item.issueDate)}`}</Typography>
            </Link>
          ))}
        </SectionPreview>
        <SectionPreview title="Упълномощител/и">{model?.authorizer}</SectionPreview>
        <SectionPreview title="Упълномощен/и">{model?.authorized}</SectionPreview>
        <SectionPreview title="Описание">{model?.description}</SectionPreview>
        {model?.file?.blobId && (
          <SectionPreview title="Сканирано копие">
            <Button
              startIcon={<AttachFileIcon />}
              variant="outlined"
              href={`${apiFileDownloadEndpoint}/${model?.file?.blobId}`}
            >
              {model?.file?.name}
            </Button>
          </SectionPreview>
        )}
      </Stack>
    );
  };

  return model ? render() : null;
};

export default Authorization;
